module.exports = "https://static.wmbcdn.com/uniweb/images/db3df1948b961b358967812bc8081ca9.svg";